import { css } from 'styled-components';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      @media (max-width: ",
        "px) {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      @media (min-width: ",
        "px) {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      @media (min-width: ",
        "px) {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      @media (max-width: ",
        "px) and (min-width: ",
        "px) {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      @media (max-width: ",
        "px) {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n        @media ",
        " {\n          ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function minWidthMediaQuery(minValue) {
    return minValue != null ? "(min-width: ".concat(minValue, ")") : "";
}
function maxWidthMediaQuery(maxValue) {
    return maxValue != null ? "(max-width: ".concat(Number.parseInt(maxValue.replace("px", "")) - 1, "px)") : "";
}
function minMaxWidthMediaQuery(breakpoints, breakpointIndex) {
    return [
        minWidthMediaQuery(breakpoints[breakpointIndex] != null ? breakpoints[breakpointIndex - 1] : breakpoints[breakpoints.length - 1]),
        maxWidthMediaQuery(breakpoints[breakpointIndex])
    ].filter(Boolean).join(" and ");
}
function generateMediaQueries(param) {
    var _param = _sliced_to_array(param, 2), mobile = _param[0], desktop = _param[1];
    return {
        upToDesktop: function(first) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return css(_templateObject(), desktop, css.apply(void 0, [
                first
            ].concat(_to_consumable_array(args))));
        },
        tabletAndDesktop: function(first) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return css(_templateObject1(), mobile, css.apply(void 0, [
                first
            ].concat(_to_consumable_array(args))));
        },
        desktop: function(first) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return css(_templateObject2(), desktop, css.apply(void 0, [
                first
            ].concat(_to_consumable_array(args))));
        },
        tablet: function(first) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return css(_templateObject3(), desktop, mobile, css.apply(void 0, [
                first
            ].concat(_to_consumable_array(args))));
        },
        mobile: function(first) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return css(_templateObject4(), mobile - 1, css.apply(void 0, [
                first
            ].concat(_to_consumable_array(args))));
        },
        breakpoint: function(breakpointIndex) {
            return function(first) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return css(_templateObject5(), function(props) {
                    return minMaxWidthMediaQuery(props.theme.breakpoints, breakpointIndex);
                }, css.apply(void 0, [
                    first
                ].concat(_to_consumable_array(args))));
            };
        }
    };
}

export { generateMediaQueries, maxWidthMediaQuery, minMaxWidthMediaQuery, minWidthMediaQuery };
